var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "access-denied"
  }, [_c('div', {
    staticClass: "background",
    style: {
      'background-color': _vm.bgColor
    }
  }), _c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper d-flex align-items-center justify-content-center auth theme-one"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-lg-4 mx-auto"
  }, [_c('div', {
    staticClass: "auto-form-wrapper text-center"
  }, [_vm.logoUrl ? _c('div', {
    staticClass: "mb-3"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoUrl
    }
  })]) : _vm._e(), _c('h3', {
    staticClass: "denied-title mb-4"
  }, [_vm._v(_vm._s(_vm.deniedTitle))]), _c('p', {
    staticClass: "denied-message mt-2 text-center"
  }, [_vm._v(" " + _vm._s(_vm.deniedMessage) + " ")]), _c('div', {
    staticClass: "login-meta mt-5 text-center"
  }, [_c('p', [_vm._v("登入 IP：" + _vm._s(_vm.deniedLoginIp))]), _c('p', [_vm._v("登入時間：" + _vm._s(_vm.deniedLoginTime))])]), _c('div', {
    staticClass: "mt-4"
  }, [_c('router-link', {
    staticClass: "back-login",
    attrs: {
      "to": _vm.loginRoute
    }
  }, [_vm._v(" 返回登入頁 ")])], 1)])])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }